import { dbh_helper } from '../src/dbh_helper';
import { dbh_ajax } from '../src/dbh_ajax';

$(document).ready(function () {
    $('#dbh_Beschwerdemanagement').ready(() => {
        const messageTextarea = $('#Message');
        const charCounter = $('#char-counter');
        const btnSend = $('#btnSend');
        const maxLength = parseInt(messageTextarea.attr('maxlength') || '0', 10);

        function updateCharCounter() {
            const currentLength = (messageTextarea.val() as string).length;
            const remaining = maxLength - currentLength;

            charCounter.text(`${remaining} Zeichen übrig`);

            if (remaining < 0) {
                charCounter.addClass('error');
                btnSend.prop('disabled', true);
            } else {
                charCounter.removeClass('error');
                btnSend.prop('disabled', false);
            }
        }

        if (maxLength > 0) {
            updateCharCounter();
            messageTextarea.on('input', updateCharCounter);
        }

        btnSend.off('click');
        btnSend.on('click', function (e) {
            e.preventDefault();

            const message = $('#Message').val();
            const id = $('#FK_Jugendlicher').val();

            if (!message || !id) {
                $('.error-message').addClass('active');
                return;
            } else {
                $('.error-message').removeClass('active');
            }

            new dbh_ajax().sendPostRequest({
                csrfToken: $('input[name="__RequestVerificationToken"]').val()?.toString() || '',
                actionName: "Create",
                controllerName: "Beschwerdemanagement",
                processData: true,
                parameter: {
                    message: message,
                    id: id
                },
                callbackSuccess: function () {
                    $('#complaintForm').hide();
                    $('.success-message').addClass('active');
                },
                callbackError: function (xhr: any) {
                    let errorMsg = 'Fehler beim Absenden. Bitte versuchen Sie es erneut.';
                    if (xhr && xhr.responseJSON && xhr.responseJSON.error) {
                        errorMsg = xhr.responseJSON.error;
                    }
                    $('.error-message').text(errorMsg).addClass('active');
                }
            });
        });
    });
});